// Render plain text only. List markers must start a line, never split a sentence.
export function formatDescription(value) {
  const escape = text => text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  let html = '', paragraph = [], list = '', items = [];
  const flushParagraph = () => {
    if (paragraph.length) html += `<p class="desc-paragraph">${paragraph.map(escape).join('<br>')}</p>`;
    paragraph = [];
  };
  const flushList = () => {
    if (items.length) html += `<${list} class="desc-list">${items.map(lines => `<li>${lines.map(escape).join('<br>')}</li>`).join('')}</${list}>`;
    items = []; list = '';
  };
  for (const line of String(value || '').replace(/\r\n?/g, '\n').split('\n')) {
    const bullet = line.match(/^\s*[-−•*]\s+(.+)$/);
    const ordered = line.match(/^\s*\d+[.)]\s+(.+)$/);
    const type = bullet ? 'ul' : ordered ? 'ol' : '';
    if (type) {
      flushParagraph();
      if (list && list !== type) flushList();
      list = type; items.push([(bullet || ordered)[1]]);
    } else {
      if (!line.trim()) { flushList(); flushParagraph(); }
      else if (items.length) items[items.length - 1].push(line);
      else paragraph.push(line);
    }
  }
  flushParagraph(); flushList();
  return html;
}
